import { Location } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  output,
  OutputEmitterRef,
  Signal,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { IconComponent } from '@libs/components/icons';
import { NavItemModel, NavModel } from '@libs/shared/models';
import { NavigationService } from '@libs/shared/services';
import { NavLinkDirective } from '@libs/shared/ui';

@Component({
  selector: 'ui-lekkerland-mobile-navigation',
  templateUrl: './lekkerland-mobile-navigation.component.html',
  styleUrl: './lekkerland-mobile-navigation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IconComponent,
    NavLinkDirective,
  ],
  standalone: true,
})
export class LekkerlandMobileNavigationComponent {
  private readonly navigationService: NavigationService = inject(NavigationService);
  private readonly location: Location = inject(Location);

  private readonly mainNavigation: Signal<NavModel | undefined> = toSignal(
    this.navigationService.getMainNavigation(),
    { initialValue: undefined },
  );

  public readonly closeNavigation: OutputEmitterRef<void> = output<void>();

  public readonly items: Signal<readonly NavItemModel[]> = computed(
    (): readonly NavItemModel[] => this.mainNavigation()?.children ?? [],
  );

  public isActive(url: string): boolean {
    const currentPath: string = this.location.path(true);

    return this.normalizePath(currentPath) === this.normalizePath(url);
  }

  private normalizePath(path: string): string {
    return decodeURI(path).replace('/#', '#');
  }
}
